import React, { SVGProps } from 'react'

const SvgSidenavManagerReviewActive = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6666 1.8913V5.33341C11.6666 5.80012 11.6666 6.03348 11.7575 6.21174C11.8374 6.36854 11.9649 6.49602 12.1217 6.57592C12.2999 6.66675 12.5333 6.66675 13 6.66675H16.4421M7.49998 13.3334L9.16665 15L12.9166 11.25M11.6666 1.66669H7.33331C5.93318 1.66669 5.23312 1.66669 4.69834 1.93917C4.22793 2.17885 3.84548 2.56131 3.6058 3.03171C3.33331 3.56649 3.33331 4.26656 3.33331 5.66669V14.3334C3.33331 15.7335 3.33331 16.4336 3.6058 16.9683C3.84548 17.4387 4.22793 17.8212 4.69834 18.0609C5.23312 18.3334 5.93318 18.3334 7.33331 18.3334H12.6666C14.0668 18.3334 14.7668 18.3334 15.3016 18.0609C15.772 17.8212 16.1545 17.4387 16.3942 16.9683C16.6666 16.4336 16.6666 15.7335 16.6666 14.3334V6.66669L11.6666 1.66669Z"
      stroke={props.stroke || 'var(--color-cta)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgSidenavManagerReviewActive
